export default __webpack_public_path__ + "static/white-natural-cork-e8a00f5f4a8b3fe7d9c022c43c8519f1.png";